import withGlobalAppLayout from './withGlobalAppLayout';
export default withGlobalAppLayout;
